import { useState } from "react";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";

const NavBar = () => {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(!active);
  };

  return (
    <>
      <nav className="sticky top-0 z-30 flex items-center flex-wrap bg-purple-900 px-3 py-1">
        <a href="/">
          <div className="inline-flex items-center text-white p-2 mr-4 ">
            {/* <img
              src="/images/vs.png"
              className="w-4 mr-2 h-auto"
              alt="SoundOff Logo"
            /> */}
            <ElectricBoltIcon color="inherit" />
            <span className="text-lg text-white font-bold uppercase tracking-wide ml-2">
              SoundOff
            </span>
          </div>
        </a>
        <button
          className=" inline-flex p-3 hover:bg-blue-600 rounded lg:hidden text-white ml-auto hover:text-white outline-none"
          onClick={handleClick}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <div
          className={`${
            active ? "" : "hidden"
          }   w-full lg:inline-flex lg:flex-grow lg:w-auto`}
        >
          <div className="lg:inline-flex lg:flex-row lg:ml-auto lg:w-auto w-full lg:items-center items-start  flex flex-col lg:h-auto">
            <a href="/faq">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400">
                FAQs
              </div>
            </a>            
            <a href="/ads">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400">
                More Streams
              </div>
            </a>
            <a href="/get-stats">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400">
                Statistics
              </div>
            </a>
            <a href="/submission">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400">
                Submission
              </div>
            </a>
            <a href="/skipline">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400">
                Skip The Line
              </div>
            </a>
            <a href="https://soundoff.canny.io/feature-requests" target="_blank" rel="noreferrer">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400">
                Feature Requests
              </div>
            </a>
            <a href="/referral">
              <div className="lg:inline-flex lg:w-auto w-full px-3 py-2 text-white font-medium items-center justify-center hover:text-blue-400 ">
                Referral
              </div>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;

// import React, { useState } from "react";
// import {
//   AppBar,
//   IconButton,
//   Toolbar,
//   Drawer,
//   useMediaQuery,
// } from "@mui/material";
// import {
//   Menu,
// } from "@mui/icons-material";
// import { useTheme } from "@mui/styles";
// import useStyles from "./style";
// import SideBar from "../SideBar/SideBar";

// function NavBar(props) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const classes = useStyles();
//   const isMobile = useMediaQuery("(max-width: 600px)");
//   const theme = useTheme();

//   return (
//     <>
//       <div className="sm:hidden">
//         <AppBar position="fixed" sx={{ height: "60px" }} className="bg-blue-600">
//           <Toolbar className={classes.toolbar}>
//             {isMobile && (
//               <IconButton
//                 color="inherit"
//                 edge="start"
//                 style={{ outline: "none" }}
//                 onClick={() => setMobileOpen((prev) => !prev)}
//                 className={classes.menuButton}
//               >
//                 <Menu />
//               </IconButton>
//             )}
//           </Toolbar>
//         </AppBar>
//       </div>
//       {/* Sidebar */}
//       <div className="hidden">
//         <nav className={classes.drawer}>
//           {isMobile ? (
//             <Drawer
//               variant="temporary"
//               anchor="left"
//               open={mobileOpen}
//               onClose={() => setMobileOpen((prev) => !prev)}
//               classes={{ paper: classes.drawerPaper }}
//               ModalProps={{ keepMounted: true }}
//             >
//               <SideBar setMobileOpen={setMobileOpen} />
//             </Drawer>
//           ) : (
//             <Drawer
//               classes={{ paper: classes.drawerPaper }}
//               variant="permanent"
//               open
//             >
//               <SideBar setMobileOpen={setMobileOpen} />
//             </Drawer>
//           )}
//         </nav>
//       </div>
//     </>
//   );
// }

// export default NavBar;
